export const chunk = (array, size) =>
  array.reduce((acc, item, idx) => {
    const chunkIndex = Math.floor(idx / size);
    if (!acc[chunkIndex]) acc[chunkIndex] = [];
    acc[chunkIndex].push(item);
    return acc;
  }, []);
